import type { MapRef } from 'react-map-gl/mapbox';

const getExploreServiceViewport = (map?: MapRef) => {
  if (!map) {
    return undefined;
  }
  const mapContainer = map.getContainer();
  const mapPadding = map.getPadding();
  if (mapContainer) {
    return {
      width: mapContainer.offsetWidth - (mapPadding.left ?? 0) - (mapPadding.right ?? 0),
      height: mapContainer.offsetHeight - (mapPadding.top ?? 0) - (mapPadding.bottom ?? 0)
    };
  }
  return undefined;
};

export default getExploreServiceViewport;
